<template>
	<div class="clx-video">
		<titles :names="'leavemessage'"></titles>
		<!-- 主体 -->
		<div class="clx-home-main">
			<div class="clx-home-main-background"></div>
			<!-- 详情 -->
			<div class="clx-home-main-content">
				<div class="clx-home-main-content-msgbox">
					<div  @click="tourl">
						<img src="../../assets/jjydt/hdly/hdly.jpg" >
					</div>

<!--					<span style="color: #0050D0;font-size: 0.34rem;font-weight: 500;margin-top: 0.25rem;"-->
<!--						@click="tourl">点击图片参与线索征集</span>-->
					<span
						class="msgbox-span2" @click="tourl">面向全省开展“1+20”政策体系落实情况问题线索征集活动，针对责任单位政策执行情况，各市场主体政策享受情况及成效，是否在时间节点要求内落实，政策在具体落实过程中存在的问题等方面，欢迎您提出宝贵的意见建议。点击下方按钮即可参与。</span>
					<div class="endbtnbox" @click="tourl">
						<span class="endbtn">我要反馈问题</span>
					</div>
					<div class="endbtnbox" style="margin-top: 0.2rem" @click="toopenend">
						<span class="endbtn">查询反馈结果</span>
					</div>
				</div>
			</div>
		</div>
		<!-- <div v-if="videoModelShow" class="showbox">
			<iframe id="iframeContainer"  width="100%" height="800" src="http://wzhb.hebei.com.cn/wz/index.php/Home/Mobilenew/add"
				frameborder="0"></iframe>
		</div> -->
	</div>
</template>

<script>
	import titles from '../../components/pagetitle/title'
	export default {
		name: "lawyer-c",
		components: {
			titles
		},
		data() {
			return {
				keyword: '', //要搜索关键字
				videoModelShow: false, //视频弹窗隐藏
				videoplayer: '',
				imgsrc: '',
			}
		},

		methods: {

			// 查询
			iSearch() {
				if (!this.keyword) {
					this.$clxTools.iMessage(this, 'e', '请输入内容后查询', 4)
					return
				}
				this.$router.push({
					name: 'result',
					params: {
						keyword: this.keyword
					}
				})
			},
			tourl() {
				// this.videoModelShow = true
				window.open('http://wzhb.hebei.com.cn/wz/index.php/Home/Mobilenew/add_dept?dept_id=3363')
			},
			toopenend() {
				window.location.href='http://wzhb.hebei.com.cn/wz/index.php/home/mobilenew/check_only.html'
				// this.videoModelShow = true
				// window.open('http://wzhb.hebei.com.cn/wz/index.php/Home/Mobilenew/main_list')
			}
		},
		created() {
			let keyword = this.$route.params.keyword
		},
		mounted() {
			if (window.screen.width > 750) {
				console.log("", window.screen.width)
				const html = document.querySelector('html');
				const width = window.screen.width
				html.style.fontSize = width / 13 + 'px'
			}
		},
	};
</script>

<style lang="less">
	.clx-video {
		width: 7.5rem;
		padding: 0 0.24rem;
		margin: 0 auto;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		-webkit-user-select: none;
		-webkit-touch-callout: none;
		background: url(../../assets/clx-images/big-bg2.jpg) no-repeat center 0px;
		background-size: cover;

		// 主体
		.clx-home-main {
			// height: ~"calc(100vh -6rem)";
			// min-height: 5rem;
			height: 58%;
			position: relative;
			border-radius: 0.1rem;
			width: 100%;
			overflow: hidden;

			.clx-home-main-background {
				top: 0;
				position: absolute;
				width: 100%;
				height: 100%;
				background-color: #fff;
				border-radius: 0.2rem;
				border: 0.01rem solid #FFC35D;
				opacity: 0.4;
				z-index: 1;
			}

			// 内容
			.clx-home-main-content {
				// padding: 0.32rem 0.3rem;
				height: 100%;
				z-index: 2;
				position: absolute;
				overflow-x: hidden;
				overflow-y: auto;
				padding: 0.3rem 0.15rem;

				.clx-home-main-content-msgbox {
					display: flex;
					flex-direction: column;
					justify-content: space-around;
					align-items: center;

					img {
						max-width: 100%;
					}

					.msgbox-span2 {
						width: 90%;
						font-size: 0.32rem;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #272727;
						margin-top: 0.2rem;
					}

					.endbtnbox {
						width: 100%;
						display: flex;
						justify-content: center;
						align-items: center;

						.endbtn {
							display: flex;
							justify-content: center;
							align-items: center;
							width: 40%;
							background: linear-gradient(to bottom, #378cee, #005de0);
							color: #fff;
							border-radius: 0.15rem;
							padding: 0.1rem 0;
							margin-top: 0.2rem;

						}
					}
				}

				// 滚动条
				&::-webkit-scrollbar-track-piece {
					background-color: rgba(0, 0, 0, 0);
					border-left: 1px solid rgba(0, 0, 0, 0);
				}

				&::-webkit-scrollbar {
					width: 2px;
					height: 13px;
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
				}

				&::-webkit-scrollbar-thumb {
					background-color: rgba(0, 0, 0, 0.2);
					background-clip: padding-box;
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
					min-height: 28px;
				}

				&::-webkit-scrollbar-thumb:hover {
					background-color: rgba(0, 0, 0, 0.2);
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
				}
			}
		}

		.showbox {
			position: fixed;
			z-index: 20;
			top: 0;
			// left: 0;
			max-width: 7.5rem;
			width: 100%;
			height: 100%;
			overflow-x: hidden;
			overflow-y: auto;
			background-color: #fff;
			// padding: 0.3rem 0.6rem;
		}
	}
</style>
